<template>
    <div class="tsa-loading" v-show="show">
        <div class="mask" @touchmove.prevent></div>
        <div class="tsa-loadin-content">
            <mt-spinner type="fading-circle"></mt-spinner>
            <p>{{ text }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tsa-loading',
    data () {
        return {
            show: false,
            text: '加载中'
        }
    }
}
</script>

<style>
    .tsa-loading {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 999;
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0,0,0,0);
    }
    .tsa-loadin-content {
        width: 100px;
        height: 100px;
        top: 50%;
        left: 50%;
        padding: 20px;
        position: absolute;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-align: center;
    }
    .tsa-loadin-content .mint-spinner-fading-circle {
        margin: 0 auto;
    }
    .tsa-loadin-content p {
        margin-top: 10px;
        font-size: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Loading/index.vue